module.exports = __webpack_public_path__ + "static/media/Mentorness logo.d1820081.jpg";